<template>
  <fragment>
    <!-- Выбор специальности или врача -->
    <select-speciality-or-doctor-step
      v-if="step === WIDGET_STEP__SELECT_SPEC_OR_DOCTOR"
      @change-filial="dialogFilial = true"
      @change-step="setStep($event)"
    />

    <!-- Выбор врача (только если ранее была выбрана специальность) -->
    <select-doctor-step
      v-if="step === WIDGET_STEP__SELECT_DOCTOR"
      @change-step="setStep($event)"
    />

    <!-- Выбор филиала -->
    <select-filial-step
      v-if="step === WIDGET_STEP__SELECT_FILIAL"
      @change-step="setStep($event)"
    />

    <!-- Выбор услуги -->
    <select-service-step
      v-if="step === WIDGET_STEP__SELECT_SERVICE"
      @change-step="setStep($event)"
    />

    <!-- Выбор расписания -->
    <select-schedule-step
      v-if="step === WIDGET_STEP__SELECT_SCHEDULE"
      @change-step="setStep($event)"
    />

    <!-- Заполнение данных пациента -->
    <patient-data-step
      v-if="step === WIDGET_STEP__PATIENT_DATA"
      @change-step="setStep($event)"
    />

    <!-- Подтверждение телефона -->
    <confirm-phone-step
      v-if="step === WIDGET_STEP__CONFIRM_PHONE"
      @change-step="setStep($event)"
    />

    <!-- Результат записи -->
    <final-step
      v-if="step === WIDGET_STEP__FINAL"
    />
  </fragment>
</template>

<script>
import {Fragment} from "vue-frag"
import SelectSpecialityOrDoctorStep
  from "@/components/pages/steps/select-speciality-or-doctor/SelectSpecialityOrDoctorStep"
import {
  WIDGET_STEP__SELECT_DOCTOR,
  WIDGET_STEP__SELECT_SPEC_OR_DOCTOR,
  WIDGET_STEP__SELECT_FILIAL,
  WIDGET_STEP__SELECT_SERVICE,
  WIDGET_STEP__SELECT_SCHEDULE,
  WIDGET_STEP__PATIENT_DATA,
  WIDGET_STEP__CONFIRM_PHONE,
  WIDGET_STEP__FINAL
} from "@/plugins/consts"
import SelectFilialStep from "@/components/pages/steps/select-filial/SelectFilialStep"
import SelectServiceStep from "@/components/pages/steps/select-service/SelectServiceStep"
import PatientDataStep from "@/components/pages/steps/patient-data/PatientDataStep"
import ConfirmPhoneStep from "@/components/pages/steps/confirm-phone/ConfirmPhoneStep"
import FinalStep from "@/components/pages/steps/final-step/FinalStep"
import {mapGetters} from "vuex"
import SelectDoctorStep from "@/components/pages/steps/select-doctor/SelectDoctorStep.vue"
import SelectScheduleStep from "@/components/pages/steps/select-schedule/SelectScheduleStep.vue"

export default {
  components: {
    SelectScheduleStep,
    FinalStep,
    ConfirmPhoneStep,
    Fragment,
    SelectSpecialityOrDoctorStep,
    SelectDoctorStep,
    SelectFilialStep,
    SelectServiceStep,
    PatientDataStep,
  },
  data() {
    return {
      WIDGET_STEP__SELECT_SPEC_OR_DOCTOR,
      WIDGET_STEP__SELECT_DOCTOR,
      WIDGET_STEP__SELECT_FILIAL,
      WIDGET_STEP__SELECT_SERVICE,
      WIDGET_STEP__SELECT_SCHEDULE,
      WIDGET_STEP__PATIENT_DATA,
      WIDGET_STEP__CONFIRM_PHONE,
      WIDGET_STEP__FINAL,

      dialogFilial: false,
    }
  },
  computed: {
    ...mapGetters([
      'step',
    ]),
  },
  async mounted() {
    this.$nextTick(async () => {
      await this.getScheduleInfo()
    })
  },
  methods: {
    /**
     * Получение списков врачей, специальностей и филиалов (для шага 1)
     */
    async getScheduleInfo() {
      this.$eventBus.$emit('show-overlay', true)
      await this.$axios
        .get(`${this.$backendLink}/widget/schedule-info`)
        .then(response => {
          const data = response.data
          this.$store.commit('setDoctorList', data.doctors.map(it => ({id: it.id, name: it.name, note: it.note})))
          let filialList = data.filials.map(it => ({id: it.id, name: it.shortName}))
          this.$store.commit('setFilialList', filialList)
          //Если филиал всего один - сразу выбираем его
          if (filialList.length === 1) {
            this.$store.commit('setDefaultFilialId', filialList[0].id)
          }
          this.$store.commit('setSpecialitiesList', data.specialities)
        })
        .finally(() => {
          this.$eventBus.$emit('show-overlay', false)
        })
    },

    setStep(val) {
      this.$store.commit('setStep', val)
    }
  }
}
</script>
